import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsbCarouselComponent } from './usb-carousel.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    UsbCarouselComponent
  ],
  exports: [
    UsbCarouselComponent
  ]
})
export class UsbCarouselModule { }
